import { render } from "./SuggestTemple.vue?vue&type=template&id=4dade6b5"
import script from "./SuggestTemple.vue?vue&type=script&lang=js"
export * from "./SuggestTemple.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__